<template>
  <div class="page-wrapper">
    <div style="height: 80px; width: 100%">
      <div class="container-fluid" style="background-color: #ddd;">
        <div class="row">
          <div class="col-12 text-left" style="line-height: 80px; ">
            <button class="btn" v-bind:class="{'selected-mode': mode === 'orders'}" @click="changeMode('orders')">Orders</button>
            <button class="btn" v-bind:class="{'selected-mode': mode === 'categories'}" @click="changeMode('categories')">Categories</button>
            <button class="btn" v-bind:class="{'selected-mode': mode === 'businesses'}" @click="changeMode('businesses')">Businesses</button>
            <button class="btn" v-bind:class="{'selected-mode': mode === 'comProducts'}" @click="changeMode('comProducts')">Commerce Products</button>
            <button class="btn" v-bind:class="{'selected-mode': mode === 'products'}" @click="changeMode('products')">Kokoro Products</button>
            <button class="btn" v-bind:class="{'selected-mode': mode === 'news'}" @click="changeMode('news')">News</button>
            <button class="btn" v-bind:class="{'selected-mode': mode === 'site'}" @click="changeMode('site')">Site</button>
            <button class="btn" v-bind:class="{'selected-mode': mode === 'setting'}" @click="changeMode('setting')">Setting</button>
          </div>
        </div>
      </div>
    </div>
    <div style="height: calc(100% - 80px); width: 100%;">
      <template v-if="mode === 'orders'">
        <div class="container-fluid">
          <div class="row" style="background-color: white;">
            <div class="col-6 text-left" style="height: 50px; font-size: 18px;line-height: 50px;">
              <b>Orders</b>
            </div>
            <div class="col-6">

            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <table class="table">
                <tr>
                  <th>Ordered Time</th>
                  <th>Authorised</th>
                  <th>Payment</th>
                  <th>Recipient</th>
                  <th class="text-left">Address</th>
                  <th class="text-left">Items</th>
                  <th>Status</th>
                  <th>Action</th>

                </tr>
                <template v-for="order in orders">
                  <tr v-bind:key="'order-item-' + order.id">
                    <td>{{millisToDate(order.createdTime)}}</td>
                    <td>{{(order.authorisedAmount/100.0).toFixed(2)}} </td>
                    <td><span v-if="order.cardPayment > 0">{{(order.cardPayment/100.0).toFixed(2)}}</span></td>
                    <td>{{order.recipient}}</td>
                    <td class="text-left">
                      {{order.address}}
                      <br/>
                      {{order.contact}}
                      <br/>
                      {{order.email}}
                    </td>
                    <td class="text-left">
                      <template v-for="item in order.items">
                        <div v-bind:key="'order-' + order.id + '-item-' + item.id">
                          {{item.title}} x {{item.quantity}}
                        </div>
                      </template>
                    </td>
                    <td>
                      {{getStateText(order.state)}}
                    </td>
                    <td><button v-if="order.authorisedAmount > 0 && order.paidTime === 0" class="btn btn-primary" @click="acceptOrder(order)">Accept</button></td>
                  </tr>

                </template>
              </table>
            </div>
          </div>

        </div>
      </template>
      <template v-if="mode === 'categories'">
        <div class="container-fluid">
          <div class="row" style="padding-top: 20px;">
            <div class="col-6 text-left">
              <button class="btn btn-success" @click="newMetaItemView('category')">Add Category</button>
            </div>
            <div class="col-6 text-right">
              <button class="btn" v-bind:class="{'btn-primary': categoryReorder === true}" @click="categoryReorder = !categoryReorder">Move Categories</button>
            </div>
            <div class="col-12">
              <div class="category-item-container">
                <draggable v-model="categories" :options="{disabled: categoryReorder === false, animation:300}" :group="categories" @start="drag=true" @end="drag=false"  @change="onCategoryReordered">
    <!--            <div  class="col-12 col-md-3 col-lg-2">-->
                  <div v-for="cat in categories" v-bind:key="'category-item-view-' + cat.id" class="meta-category-item" @click="openMetaItemView(cat.id)">{{cat.title}}</div>
    <!--            </div>-->
                </draggable>
              </div>
            </div>
          </div>

        </div>

      </template>
      <template v-else-if="mode === 'businesses'">
        <div class="container-fluid">
          <div class="row">
            <div v-for="b in businesses" class="col-3">
              <div class="meta-category-item" @click="openMetaItemView(b.id)">{{b.title}}</div>
            </div>
          </div>
          <button class="btn btn-success" @click="newMetaItemView('business')">ADD</button>
        </div>

      </template>
      <template v-else-if="mode === 'comProducts'">
        <div style="height: 100%; width: 100%; display: flex;">
          <div style="width: 200px; height: 100%; overflow-y:scroll">
            <template  v-for="cat in categories">
              <div class="ccm-category-list-item" v-bind:key="'cat-item-' + cat.id" @click="getComProductList(cat.id)">{{cat.title}}</div>
            </template>
          </div>
          <div style="width: calc(100% - 200px); height: 100%">
            <div style="width: 100%; height: 50px; line-height: 50px; text-align: left; padding-left: 10px;">
              Search <input style="height: 40px; width: 300px;" v-model="searchComProductWord"/> <span style="height: 50px; line-height: 50px; font-size: 20px;" @click="searchComProductWord = ''"><i class="fas fa-times"></i></span>
            </div>
            <div style="width: 100%; height: calc(100% - 50px); overflow-y: scroll">
              <table class="table" v-if="products.length > 0">
                <thead>
                <tr class="stick-top-row">
                  <th></th>
                  <th class="text-left">Title</th>
                  <th class="text-left">Size</th>
                  <th class="text-right">Units</th>
                  <th class="text-right">NET</th>
                  <th class="text-right">VAT</th>
                  <th class="text-right">GROSS</th>
                  <th class="text-right">Status</th>
                </tr>
                </thead>
                <template v-for="(p, pi) in products">
                  <tr v-bind:key="'com-product-item-row-'+p.id" v-if="searchComProductWord.length <= 2 || p.title.toUpperCase().includes(searchComProductWord.toUpperCase())" @click="openProductItem(p.id)">
                    <td>{{pi+1}}</td>
                    <td class="text-left">{{p.title}}</td>
                    <td class="text-left">{{p.size}}</td>
                    <td class="text-right">{{p.units}}</td>
                    <td class="text-right">{{p.netFloat}}</td>
                    <td class="text-right">{{p.vatFloat}}</td>
                    <td class="text-right">{{p.grossFloat}}</td>
                    <td class="text-right">
                      <span v-if="p.active === true">Active</span>
                      <span v-else>Inactive</span>
                    </td>
                  </tr>
                </template>
              </table>

            </div>
          </div>
        </div>
      </template>
      <template v-else-if="mode === 'products'">
        <div style="height: 100%; width: 100%; display: flex;">
          <div style="width: 200px; height: 100%; overflow-y:scroll">
            <template  v-for="cat in kokoroCategories">
              <div class="ccm-category-list-item" v-bind:key="'cat-item-' + cat.id" @click="selectKokoroCategory(cat.id)">{{cat.title}}</div>
            </template>
          </div>
          <div style="width: calc(100% - 200px); height: 100%">
            <div style="width: 100%; height: 50px; text-align: left; padding-left: 15px;">
              Search <input v-model="searchWord" style="width: 300px; height: 50px; line-height: 50px;"/> <span @click="searchWord = ''">Clear</span>
            </div>
            <div style="width: 100%; height: calc(100% - 50px); overflow-y: scroll">
              <table class="table" v-if="kokoroProducts.length > 0">
                <thead>
                <tr class="stick-top-row">
                  <th style="display:none;">Ref</th>
                  <th></th>
                  <th class="text-left">Code</th>
                  <th class="text-left">Title</th>
                  <th>Prime Cost</th>
                  <th>Stock</th>
                  <th>Weight</th>
                  <th>on sale</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item, index) in kokoroProducts">
                  <tr class="hover-item"  :key="item.id" v-if="searchWord === null || searchWord.length < 2 || item.title.toUpperCase().includes(searchWord.toUpperCase())">
                    <td style="display:none;">#{{item.id}}</td>
                    <td class="text-left">
                      <button class="btn btn-primary" v-if="item.comProduct === null" @click="preCreateProduct(item.id)">Make Onlin Product</button>
                      <span v-if="item.comProduct !== null" @click="openProductItem(item.comProduct.id)">{{item.comProduct.title}}</span>

                    </td>
                    <td class="text-left">{{item.code}}</td>
                    <td class="text-left">{{item.title}}<span v-if="item.deleted === true">&nbsp;&nbsp; <strong>DELETED</strong></span></td>
                    <td>{{(item.sourcePrice/100.0).toFixed(2)}}</td>
                    <td>
                      <div v-if="item.parentId == 0"  class="hover-border">{{item.currentStock}}<span v-if="item.minStock > 0">/{{item.minStock}} <i v-if="item.currentStock < item.minStock" class="fas fa-exclamation-circle"></i></span>
                      </div>
                      <span v-else>
                          Child
                        </span>
                    </td>
                    <td>{{(item.weight/100).toFixed(2)}}Kg</td>
                    <td>
                      <i v-if="item.available==true" class="fas fa-check" style="color: green;"></i>
                      <i v-else class="fas fa-times" style="color: red;"></i>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </template>
      <template v-else-if="mode === 'site'">
<!--        <div class="container-fluid">-->
<!--          <div class="row">-->
<!--            <div class="col-12">-->
<!--              Site images-->
<!--            </div>-->

<!--          </div>-->
<!--        </div>-->
        <div class="container-fluid">
          <div class="row">
            <div class="col-12" style="line-height: 50px; font-size: 18px; font-weight: bold;">
              Site images (Images on top of the site)
            </div>
          </div>
          <div class="row">
            <template v-for="image in siteImages">
              <div class="col-12 col-md-6 col-lg-3" v-bind:key="'site-image-item-'+image.id">
                <div class="site-image-item-container" v-bind:style="{backgroundImage: 'url(' + image.mainImage + ')'}" @click="openMetaItemView(image.id)">
<!--                  <div class="site-image-cover"></div>-->
<!--                  <div class="title">{{image.title}}</div>-->
                </div>
              </div>
            </template>
          </div>
          <div class="row" style="padding-top: 50px;">
            <div class="col-12">
              <button class="btn btn-success" @click="newMetaItemView('site-image')">ADD</button>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="mode === 'news'">
        <div class="container-fluid">
          <div class="row">
            <template v-for="news in newsItems">
              <div class="col-6 col-md-4 col-lg-3">
                <div class="news-card-container" @click="openMetaItemView(news.id)">
                  <div class="image" v-bind:style="{backgroundImage: 'url('+ news.mainImage + ')'}">

                  </div>
                  <div class="title">
                    {{news.title}}
                  </div>
                  <div class="content">
                    {{news.shortDescription}}
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="row">
            <div class="col-12">
              <button class="btn btn-success" @click="newMetaItemView('news')">ADD</button>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="mode === 'setting'">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="setting-container">

                <b>Stripe Account Setting</b>

                <table class="table">
                  <template v-for="setting in comSettings">
                    <tbody v-bind:key="'setting-' + setting.title">
                    <tr>
                      <td>{{setting.name}}</td>
                      <td><input class="form-control" v-model="setting.textValue"/></td>
                      <td><button v-if="setting.textValue !== setting.originalValue" class="btn btn-success" @click="updateSetting(setting)">SAVE</button></td>
                    </tr>
                    </tbody>
                  </template>
                </table>
              </div>
            </div>

          </div>



        </div>
      </template>
    </div>
    <div v-if="metaItem !== false" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.4);" @click="metaItem = false">
      <div style="position: absolute; top: 50%; left: 50%; width: 800px; max-width: 90%; height: 90%; transform: translate(-50%, -50%); background: white;" @click.stop="dummy">
        <ecom-meta-item-view
          :item="metaItem"
          :on-updated="onMetaItemUpdated"
          :on-deleted="onMetaItemDeleted"
          :on-close="closeMetaIteView"></ecom-meta-item-view>
      </div>
    </div>

    <div v-if="productItem !== false" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.4);" @click="productItem = false">
      <div style="position: absolute; top: 50%; left: 50%; width: 90%; max-width: 90%; height: 90%; transform: translate(-50%, -50%); background: white;" @click.stop="dummy">
        <ecom-product-item-view
          :item="productItem"
          :categories="categories"
          :businesses="businesses"
          :on-updated="onProductItemUpdated"
          :on-close="closeProductView"></ecom-product-item-view>
      </div>
    </div>
  </div>
</template>

<script>
import {
  acceptOrder,
  getComMeta,
  getComMetas, getComOrders, getComProduct, getComProducts, getComSettingDefaultList, getComSettings,
  getKokoroCategories,
  getKokoroProducts,
  getNewComMeta,
  preCreateProduct, updateComMetas, updateComSetting, updateComSettings
} from "../api/ecomApi";
import EcomMetaItemView from "./ItemView/EcomMetaItemView.vue";
import EcomProductItemView from "./ItemView/EcomProductItemView.vue";
import {setLastPage, showDialog, timeToLocaleDateShort} from "../api/utils";
import draggable from "vuedraggable";

export default {
  name: "Commerce",
  data() {
    return {
      mode:'',
      categories:[],
      businesses:[],
      products:[],
      kokoroProducts:[],
      metaItem: false,
      kokoroCategories:[],
      newsItems: [],
      selectedKokoroCategoryId:-1,
      productItem: false,
      siteImages:[],
      searchWord:'',
      searchComProductWord:'',
      categoryReorder: false,
      comSettings: [],
      orders:[],
      stateList: [
        {
          state:0,
          title:'Submitted',
        },
        {
          state:10,
          title:'Confirmed',
        },
        {
          state:50,
          title:'Dispatched',
        },
        {
          state:100,
          title:'Completed',
        },
        {
          state:-200,
          title:'Cancelled',
        },
        {
          state:-100,
          title:'Rejected',
        },
        {
          state:-2000,
          title:'Refunded',
        },

      ]

    }
  },
  components: {
    EcomMetaItemView,
    EcomProductItemView,
    draggable
  },
  created() {
    setLastPage(this.$route.path);
    this.initialise();
  },
  mounted() {
  },
  methods: {
    getStateText: function(state) {
      for(let i = 0 ; i < this.$data.stateList.length ; i++) {
        if(this.$data.stateList[i].state === state) {
          return this.$data.stateList[i].title;
        }
      }
      return '(' + state + ')';
    },
    millisToDate: function(time) {
      return timeToLocaleDateShort(time);
    },
    dummy: function() {

    },
    initialise: function() {
      this.getCategoryList();
      this.getBusinessList();
      this.getKokoroCategoryList();
    },
    changeMode: function(newMode) {
      if(this.$data.mode === newMode) {
        return;
      }
      this.$data.mode = newMode;
      console.log("mode changed to " + this.$data.mode);
      if(this.$data.mode === 'news') {
        this.getNewsItems();
      } else if(this.$data.mode === 'site') {
        this.getSiteImages();
      } else if(this.$data.mode === 'setting') {
        this.openComSettings();
      } else if(this.$data.mode === 'orders') {
        this.getOrderList();
      }
    },
    onCategoryReordered: function() {
      for(let i = 0 ; i < this.$data.categories.length ; i++) {
        this.$data.categories[i].pos = i;
      }
      let self = this;
      updateComMetas(this.$data.categories)
        .then(function(data) {

          if(data.success === true) {
            data.item.sort(function(a, b) {
              return a.pos - b.pos;
            })
            self.$data.categories = data.item;
          } else {
            console.log(data.message);
          }
        })
        .catch(function(err) {

        })
    },
    getCategoryList: function() {
      let self = this;
      this.$data.categories = [];
      getComMetas('category')
        .then(function(data) {
          console.log("category list");
          console.log(data);
          if(data.success === true) {
            data.item.sort(function(a, b) {
              return a.pos - b.pos;
            })
            self.$data.categories = data.item;
          } else {
            console.log(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },
    getBusinessList: function() {
      let self = this;
      this.$data.categories = [];
      getComMetas('business')
        .then(function(data) {
          if(data.success === true) {
            self.$data.businesses = data.item;
          } else {
            console.log(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },
    getNewsItems: function() {
      let self = this;
      this.$data.newsItems = [];
      getComMetas('news')
        .then(function(data) {
          if(data.success === true) {
            self.$data.newsItems = data.item;
          } else {
            console.log(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },
    getSiteImages: function() {
      let self = this;
      this.$data.siteImages = [];
      getComMetas('site-image')
        .then(function(data) {
          if(data.success === true) {
            self.$data.siteImages = data.item;
          } else {
            console.log(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },
    openMetaItemView: function(id) {
      let self = this;
      getComMeta(id)
        .then(function(data) {
          if(data.success === true) {
            self.$data.metaItem = data.item;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },
    newMetaItemView: function(type) {
      this.$data.metaItem = getNewComMeta(type);
    },
    closeMetaIteView: function() {
      this.$data.metaItem = false;
    },
    onMetaItemDeleted: function(item) {
      if(item.metaType === 'business') {
        for(let i = 0 ; i < this.$data.businesses.length ; i++) {
          if(this.$data.businesses[i].id === item.id) {
            this.$data.businesses.splice(i, 1);
          }
        }

      } else if(item.metaType === 'category') {
        for(let i = 0 ; i < this.$data.categories.length ; i++) {
          if(this.$data.categories[i].id === item.id) {
            this.$data.categories.splice(i, 1);

          }
        }

      } else if(item.metaType === 'news') {
        for(let i = 0 ; i < this.$data.newsItems.length ; i++) {
          if(this.$data.newsItems[i].id === item.id) {
            this.$data.newsItems.splice(i, 1);
          }
        }

      } else if(item.metaType === 'site-image') {
        for(let i = 0 ; i < this.$data.siteImages.length ; i++) {
          if(this.$data.siteImages[i].id === item.id) {
            this.$data.siteImages.splice(i, 1);

          }
        }

      }
    },
    onMetaItemUpdated: function(item) {
      if(item.metaType === 'business') {
        let found = false;
        for(let i = 0 ; i < this.$data.businesses.length ; i++) {
          if(this.$data.businesses[i].id === item.id) {
            this.$data.businesses.splice(i, 1, item);
            found = true;
          }
        }
        if(found === false) {
          this.$data.businesses.push(item);
        }
      } else if(item.metaType === 'category') {
        let found = false;
        for(let i = 0 ; i < this.$data.categories.length ; i++) {
          if(this.$data.categories[i].id === item.id) {
            this.$data.categories.splice(i, 1, item);
            found = true;
          }
        }
        if(found === false) {
          this.$data.categories.push(item);
        }
      } else if(item.metaType === 'news') {
        let found = false;
        for(let i = 0 ; i < this.$data.newsItems.length ; i++) {
          if(this.$data.newsItems[i].id === item.id) {
            this.$data.newsItems.splice(i, 1, item);
            found = true;
          }
        }
        if(found === false) {
          this.$data.newsItems.push(item);
        }
      } else if(item.metaType === 'site-image') {
        let found = false;
        for(let i = 0 ; i < this.$data.siteImages.length ; i++) {
          if(this.$data.siteImages[i].id === item.id) {
            this.$data.siteImages.splice(i, 1, item);
            found = true;
          }
        }
        if(found === false) {
          this.$data.siteImages.push(item);
        }
      }
    },
    getKokoroCategoryList: function() {
      let self = this;
      getKokoroCategories()
        .then(function(data) {
          if(data.success === true) {
            self.$data.kokoroCategories = data.item;
          }
        })
        .catch(function(err) {

        })
    },
    selectKokoroCategory: function(cid) {
      this.$data.selectedKokoroCategoryId = cid;
      let self = this;

      getKokoroProducts(cid)
        .then(function(data) {
          if(data.success === true) {
            self.$data.kokoroProducts = data.item;
          }
        })
        .catch(function(err) {
          console.log(err);
        })
    },
    openProductItem: function(id) {
      let self = this;
      getComProduct(id)
        .then(function(data) {
          if(data.success === true) {
            self.$data.productItem = data.item;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },
    preCreateProduct: function(pId) {
      let self = this;
      preCreateProduct(pId)
        .then(function(data) {
          if(data.success === true) {
            console.log("pre create item");
            console.log(data.item);
            self.$data.productItem =  data.item;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    closeProductView: function() {
      this.$data.productItem = false;
    },
    onProductItemUpdated: function(item) {
      let found = false;
      for(let i = 0 ; i < this.$data.products.length ;i++) {
        if(this.$data.products[i].id === item.id) {
          this.$data.products.splice(i, 1, item);
          found = true;
          break;
        }
      }
      if(found === false) {
        this.$data.products.push(item);
      }

      for(let i = 0 ; i < this.$data.kokoroProducts.length ; i++) {
        if(this.$data.kokoroProducts[i].id === item.productId) {
          this.$data.kokoroProducts[i].comProduct = item;
          break;
        }
      }
    },
    getComProductList: function(cid) {
      let self = this;
      this.$data.products = [];
      getComProducts("categoryId=" + cid)
        .then(function(data) {
          if(data.success === true) {
            self.$data.products = data.item;
          } else {

          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },
    openComSettings: function() {
      this.$data.comSettings = getComSettingDefaultList();

      let titles = [];
      for(let i = 0 ; i < this.$data.comSettings.length ; i++) {
        titles.push(this.$data.comSettings[i].title);
      }

      let self = this;
      let param = titles.join(',');
      getComSettings(param)
        .then(function(data) {
          if(data.success === true) {
            console.log("setting acquired " + data.item);
            self.replaceSettingItems(data.item);
          } else {
            console.log("setting acquired " + data.item);
            self.updateComSettings(self.$data.comSettings
            );
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })

    },

    replaceSettingItems: function(list) {
      for(let i = 0 ; i < list.length ; i++) {
        console.log(list[i]);
        for(let j = 0 ; j < this.$data.comSettings.length ; j++) {
          console.log("compare to");
          console.log(this.$data.comSettings[j]);
          if(this.$data.comSettings[j].title === list[i].title) {
            console.log("found");
            this.$data.comSettings.splice(j, 1, list[i]);
            break;
          }
        }
      }
    },
    updateSetting: function(item) {
      let self = this;
      updateComSetting(item)
        .then(function(data) {
          if(data.success === true) {
            console.log("setting item updated");
            console.log(data.item);
            self.replaceSettingItems([data.item]);
          } else {
            console.log("failed to update " + data.message);
          }
        })
        .catch(function(err) {
          console.log("update Com setting item error");
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },
    updateComSettings: function(list) {
      let self = this;
      updateComSettings(list)
        .then(function(data) {
          console.log("update settings ")
          console.log(data);
          if(data.success === true) {
            self.replaceSettingItems(data.item);
          } else {

          }
        })
        .catch(function(err) {

        })
    },
    getOrderList: function() {
      let self = this;

      let query = "stateFrom=0&stateTo=99";
      getComOrders(query)
        .then(function(data) {
          if(data.success === true) {
            self.$data.orders = data.item;
          } else {

          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },
    acceptOrder: function(order) {

      let self = this;
      acceptOrder(order.id)
        .then(function(data) {
          if(data.success === true) {
            for(let i = 0 ; i < self.$data.orders.length ; i++) {
              if(self.$data.orders[i].id === data.item.id) {
                self.$data.orders.splice(i, 1, data.item);
              }
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          let msg = err;
          if(err.response !== undefined) {
            console.log(err.response);
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    }
  }
}
</script>

<style scoped>
.selected-mode {
  background-color: blue;
  color:white;
}
.meta-category-item {
  padding:30px 10px;
  background-color: white;;
  border-radius: 10px;
  border: 1px solid gray;
  //margin: 10px auto;
  width: 300px;
  cursor: pointer;
  float: left;
  margin: 10px;
}
.ccm-category-list-item {
  width: 100%;
  padding-top:10px;
  padding-bottom: 10px;
  border-bottom: 1px solid gray;
  background-color: white;
}
.stick-top-row > th {
  position: sticky;
  top:0;
  background-color: #969797;
}

.news-card-container {
  background: white;
  width: calc(100% - 20px);
  margin: auto;
  margin-top:10px;
  margin-bottom: 10px;

}
.news-card-container .image {
  width: 100%;
  padding-bottom: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.news-card-container .title {
  font-weight: bold;
  padding: 5px;
  text-align: center;
  font-size: 1.5rem;
}
.news-card-container .content {
  padding: 5px;
  text-align: center;
}
.site-image-item-container {
  width: 100%;
  height: 200px;
  background-color: #969797;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
}
.site-image-item-container .site-image-cover {
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}
.site-image-item-container .title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  padding:20px;
  color:white;
  font-weight: bold;;
  font-size: 2rem;
}
.category-item-container {
  width: 100%;
  padding: 10px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Commerce.vue